<script setup lang="ts">
import { useNotFoundStatus } from '@pkg/sanity-utils/composables/useNotFoundStatus';

/**
 * Shared soft-404 shell (HTTP 404 + noindex + wrapper).
 * Apps supply page content via the default slot (ContentRenderer / ModularBlocksRenderer).
 */
useNotFoundStatus();
// Overrides the @nuxtjs/robots default (`index, follow`) for both the meta tag and X-Robots-Tag.
useRobotsRule('noindex');
</script>

<template>
  <div class="c-404">
    <slot />
  </div>
</template>

<style scoped>
.c-404 :deep(.c-base-title) {
  padding-top: 3rem;
}

.c-404 :deep([data-theme='app'] .c-base-title__header) {
  color: theme('colors.primary.30');
}
</style>
